export default "__VITE_ASSET__LyhWyKRT__"